import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Layout } from "@/components/Layout/Layout";
import { Header } from "@/components/Header/Header";
import { Loading } from "@/components/Loading/Loading";
import { LessonCard } from "@/components/LessonCard/LessonCard";
import { lessonApi } from "@/services/lessonApi";
import type { LessonSummary } from "@/types/lesson";

export function Lessons() {
  const [params] = useSearchParams();
  const subjectId = params.get("subjectId") ?? undefined;
  const [lessons, setLessons] = useState<LessonSummary[] | null>(null);

  useEffect(() => {
    setLessons(null);
    lessonApi
      .getLessons(subjectId)
      .then(setLessons)
      .catch(() => setLessons([]));
  }, [subjectId]);

  return (
    <Layout>
      <Header title="Lessons" showBack />
      <main className="flex-1 p-4">
        {!lessons ? (
          <div className="flex h-40 items-center justify-center">
            <Loading label="Fetching lessons..." />
          </div>
        ) : lessons.length === 0 ? (
          <p className="text-center text-slate-500">
            No lessons here yet — check back soon!
          </p>
        ) : (
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {lessons.map((l) => (
              <LessonCard key={l.lessonId} lesson={l} />
            ))}
          </div>
        )}
      </main>
    </Layout>
  );
}
